<div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Content</h3>
    <div data-bound-text-slash-anchor>
      <lib-signal-textarea
        label="Paragraph"
        [rows]="4"
        [trigger]="'/'"
        [handlebars]="true"
        [value]="model().label"
        (valueChange)="setLabel($event)"
        (triggerActivated)="onTriggerActivated($event)" />
    </div>
    <app-bound-text-slash-menu
      [open]="slashMenuOpen()"
      [query]="slashQuery()"
      [anchorRect]="slashAnchor()"
      (select)="onSlashSelect($event)"
      (dismiss)="onSlashDismiss()" />
    <lib-signal-dropdown
      label="Level"
      [items]="paragraphLevelOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.paragraphLevel" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Typography</h3>
    <app-typography-config-controls
      [alignment]="model().paragraphAlignment"
      [fontStyle]="model().paragraphFontStyle"
      [fontWeight]="model().paragraphFontWeight"
      (alignmentChange)="setAlignment($event)"
      (fontStyleChange)="setFontStyle($event)"
      (fontWeightChange)="setFontWeight($event)" />
    <lib-signal-dropdown
      label="Font Family"
      [items]="fontFamilyOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.paragraphFontFamily" />
    <lib-signal-color-field
      label="Font Color"
      [formField]="configForm.paragraphColor" />
  </section>
</div>
